import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useNavigate } from "react-router-dom";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import InfoIcon from "@mui/icons-material/Info";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY }
from "../../graphQL/component_qry";
import { GET_APPLICANT_DATA_BY_TERM_APPLICANT_ID_QUERY,
         GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_TERM_ID }
from "../../graphQL/term_applicant_qry";
import { APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY }
from "../../graphQL/term_applicant_answer_qry"
import { GET_TERM_DATA_BY_TERM_UUID }
from "../../graphQL/term_qry";

import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Link,
  Grid,
  Button,
  Tooltip,
  Radio,
  TextField,
  RadioGroup,
  Typography,
  Checkbox,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "185px, -20px, 20px, -180px", //"120px, -20px, 20px, -5px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    min-width: 340px;
    background: #fff;
    color: #000;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: flex;
    padding: 8px 5px 8px 5px;
    flex-direction: column;
  }
`;

const StyledTooltipCom = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "0.6rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  doneButtonStyle:{
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display: "flex",
      alignItems: "center",
      minHeight: 50,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
  },
}));

function ApplicationView() {

  const { termUuid } = useParams();
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);

  const navigate = useNavigate();

  const [pathname] = useState(window.location.pathname);

  const [rows, setRows] = useState([]);
  const [formInfo, setFormInfo] = useState("");
  const [detailRows, setDetailRows] = useState([]);
  const [applicantAnswers, setApplicantAnswers] = useState([]);
  const [applicantFormData, setApplicantFormData] = useState([]);
  const [applicantName, setApplicantName] = useState("");
  const [detailAlertMsg, setDetailAlertMsg] = useState([]);
  const [termApplicantId, setTermApplicantId] = useState("");
  const [applicantInfo, setApplicantInfo] = useState("");
  const [termInfo, setTermInfo] = useState("");

  const [applicantId, setApplicantId] =
    useState(
      localStorage.getItem("applicantId") ?
      localStorage.getItem("applicantId") :
      ""
    );

  const [fetchTermData] = useManualQuery(
    GET_TERM_DATA_BY_TERM_UUID,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchApplicantAnswers] = useManualQuery(
    APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchApplicantData] = useManualQuery(
    GET_APPLICANT_DATA_BY_TERM_APPLICANT_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchTermApplicantData] = useManualQuery(
    GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_TERM_ID,
    {
      fetchPolicy: "network-only",
    }
  );

  const classes = useStyles();

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null
                      ?
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const convertTxtToRichTxt = txt => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //Commented by Sami 30Aug2025
    let contentHTML = draftToHtml(JSON.parse(txt));
    // contentHTML = contentHTML.replace(/<p>/, "");
    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const shortenAnswer = (fullAns, length) => {
    //trim the string to the maximum length
    var trimmedString = fullAns.substr(0, length);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    return trimmedString
  }

  const openDetailDialog = (question, fullAnswer) => {
    setDetailAlertMsg({
      title: "Full Content",
      headerMsg: question,
      msg: fullAnswer,
    });
  }

  const getTermData = async () => {
    if (termUuid) {
      // Get term data by termUuid
      const {
        loading: termDataLoading,
        error: termDataError,
        data: termData,
      } = await fetchTermData({
        variables: {  termUuid: termUuid },
      });

      if (
        !termDataLoading &&
        termData &&
        termData.getTermDataByTermUuid
      ) {

        setTermInfo(termData.getTermDataByTermUuid);
      };
      if (
        termDataError &&
        termDataError.graphQLErrors &&
        termDataError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      };
    };
  }

  const getApplicantAnswers = async () => {
    if (termApplicantId) {
      // Get Applicant Answers
      const {
        loading: applicantAnswersLoading,
        error: applicantAnswersError,
        data: applicantAnswersData,
      } = await fetchApplicantAnswers({
        variables: {  termApplicantId: parseInt(termApplicantId) },
      });

      if (
        !applicantAnswersLoading &&
        applicantAnswersData &&
        applicantAnswersData.appAnswersBytermApplicantId
      ) {
        setApplicantAnswers(
          applicantAnswersData.appAnswersBytermApplicantId
        );
      };
      if (
        applicantAnswersError &&
        applicantAnswersError.graphQLErrors &&
        applicantAnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      };
    };
  }

  const getApplicantData = async () => {
    if (applicantId && termInfo && termInfo.termId){

      // Get applicant info
      const {
        loading: termApplicantDataLoading,
        error: termApplicantDataError,
        data: termApplicantData,
      } = await fetchTermApplicantData({
        variables: {
          applicantId: parseInt(applicantId),
          termId: parseInt(termInfo.termId)
        },
      });

      if (
        !termApplicantDataLoading &&
        termApplicantData &&
        termApplicantData.getAllTermApplicantsByApplicantIdTermId
      ) {
        setTermApplicantId(
          termApplicantData.getAllTermApplicantsByApplicantIdTermId.termApplicantId
        );
        setApplicantInfo(
          termApplicantData.getAllTermApplicantsByApplicantIdTermId
        );
      };

      if (
          termApplicantDataError &&
          termApplicantDataError.graphQLErrors &&
          termApplicantDataError.graphQLErrors[0].message ===
            "Signature has expired"
        ) {
          navigate(`${project_url}/signin`);
        };

      if (termApplicantId) {
        // Get applicant info
        const {
          loading: applicantDataLoading,
          error: applicantDataError,
          data: applicantData,
        } = await fetchApplicantData({
          variables: { termApplicantId: parseInt(termApplicantId) },
        });

        if (
          !applicantDataLoading &&
          applicantData &&
          applicantData.getApplicantDataByTermApplicantId
        ) {
          let frmUuid = applicantData.getApplicantDataByTermApplicantId.termId.formId.formUuid;
          setFormInfo(applicantData.getApplicantDataByTermApplicantId.termId.formId);
          setApplicantName(
            applicantData.getApplicantDataByTermApplicantId.applicantId.userId.firstName +
            " " +
            applicantData.getApplicantDataByTermApplicantId.applicantId.userId.lastName
          );
          if (frmUuid && applicantAnswers.length > 0) {

            // Get applicant answres
            const {
              loading: formComponentsAnswersLoading,
              error: formComponentsAnswersError,
              data: formComponentsAnswersData,
            } = await fetchFormComponentsAnswers({
              variables: { formUuid: frmUuid },
            });

            if (
              !formComponentsAnswersLoading &&
              formComponentsAnswersData &&
              formComponentsAnswersData.formComponentAnswerList
            ) {

              let questions =
                formComponentsAnswersData.formComponentAnswerList.componentList;
              let appDetailRows = [];

              for (var i = 0; i < questions.length; i++)
              {
                if (questions[i].answerTypeId.name !== "content")
                {
                  let appDetailRow= [];
                  appDetailRow["question"] = {
                    id: i + 1,
                    value: convertTxtToRichTxt(questions[i].label),
                    checked: true
                  };

                  appDetailRow["mandatory"] = questions[i].mandatory;

                  let foundAnswer = applicantAnswers.filter(item =>
                    item.answerId.componentId.componentId === questions[i].componentId
                  )

                  if (foundAnswer){
                    if (questions[i].answerTypeId.name === "text" ||
                        questions[i].answerTypeId.name === "textarea" ||
                        questions[i].answerTypeId.name === "drop_down" ||
                        questions[i].answerTypeId.name === "drop_down_state" ||
                        questions[i].answerTypeId.name === "drop_down_country" ||
                        questions[i].answerTypeId.name === "checkbox_single"){
                      appDetailRow["answer"] =
                        foundAnswer.length !== 0
                        ?
                          !questions[i].mandatory &&
                          foundAnswer[0].applicantAnswer === ""
                          ? "Not provided"
                          : foundAnswer[0].applicantAnswer
                        :
                        "Not provided"
                    }
                    else if (questions[i].answerTypeId.name === "checkbox_multiple" ||
                      questions[i].answerTypeId.name === "radio_button"){

                      appDetailRow["answer"] = foundAnswer.map(
                        ({ applicantAnswer }) => applicantAnswer
                      );

                      if (!questions[i].mandatory &&
                          appDetailRow.answer.length === 0 )
                        appDetailRow.answer = "Not provided";
                    };
                    appDetailRow["answerId"] = foundAnswer.map(
                      ({ answerId }) => answerId.answerId
                    );
                  };
                  appDetailRow["answerList"] =
                    questions[i].answerList.map(
                      ({ label }) => label
                    );
                  appDetailRow["type"] = questions[i].answerTypeId.name;

                  appDetailRows.push({
                    // index: row.index,
                    answerId: appDetailRow.answerId,
                    answer: appDetailRow.answer,
                    mandatory: appDetailRow.mandatory,
                    question: appDetailRow.question,
                    answerList: appDetailRow.answerList,
                    type: appDetailRow.type,
                  });
                };
              }
              setApplicantFormData(appDetailRows);
            };
            if (
              formComponentsAnswersError &&
              formComponentsAnswersError.graphQLErrors &&
              formComponentsAnswersError.graphQLErrors[0].message ===
                "Signature has expired"
            ) {
              navigate(`${project_url}/signin`);
            };
          };
        };

        if (
          applicantDataError &&
          applicantDataError.graphQLErrors &&
          applicantDataError.graphQLErrors[0].message ===
            "Signature has expired"
        ) {
          navigate(`${project_url}/signin`);
        };
      };
    };
  };

  useEffect(() => {
    (() => getTermData())();
  }, [termUuid]);

  useEffect(() => {
    (() => getApplicantData())();
  }, [termInfo, applicantAnswers]);

  useEffect(() => {
    (() => getApplicantAnswers())();
  }, [termApplicantId]);

  useEffect(() => {
    let rows = [];

    for (var i = 0; i < applicantFormData.length; i++) {
      let row = [];
      row["index"] = i;
      row["answerId"] = applicantFormData[i].answerId;
      row["answer"] = applicantFormData[i].answer;
      row["mandatory"] = applicantFormData[i].mandatory;
      row["question"] = applicantFormData[i].question;
      row["type"] = applicantFormData[i].type;
      row["answerList"] = applicantFormData[i].answerList;

      rows.push({
        index: row.index,
        answerId: row.answerId,
        answer: row.type === "checkbox_single"
                ?
                  row.answer === "true"
                  ? "Checked"
                  : "Unchecked"
                : row.answer,
        mandatory: row.mandatory,
        question: row.question,
        answerList: row.answerList,
        type: row.type,
      });
    }

    // setApplicantDetail(rows);
    setDetailRows(rows);
  }, [applicantFormData]);

  const columns = [
    {
      field: "question",
      headerName: "Question",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        let title = (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <Grid item xs={9}>
                <Typography variant="h2">Answer</Typography>
              </Grid>
            </Grid>
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "checkbox_multiple" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={false}
                        style={{ padding: 5 }}
                      />

                      <Typography variant="h3">{item}</Typography>
                    </Grid>

                  </Grid>
                )
            )}
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "radio_button" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          style={{ paddingLeft: 10 }}
                        >
                          <FormControlLabel
                            value={item}
                            control={
                              <Radio checked={false} style={{ padding: 5 }} />
                            }
                            label={
                              <Typography
                                variant="h3"
                                style={{ color: "black" }}
                              >
                                {item}
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        );
        if (
          rows.row.type === "radio_button" ||
          rows.row.type === "checkbox_multiple"
        )
          if (rows.row.mandatory)
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <StyledTooltipCom title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltipCom>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
          else
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
        else if(rows.row.mandatory)
          return(
            <Box
              pb={0.25}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <StyledTooltipCom title="required field">
                <Typography
                  variant="h3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#E53935",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  *
                </Typography>
              </StyledTooltipCom>
              <Typography variant="h2">{rows.row.question.value}</Typography>
            </Box>
          )
        else
          return (
            <Typography variant="h2">{rows.row.question.value}</Typography>
          );
      },
    },
    {
      field: "applicantAnswer",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.type === "textarea"){
          if(rows.row.answer.length < 100){
            return <Typography variant="h3">{rows.row.answer}</Typography>
          }
          else
          {
            return (
                <Typography
                  style={{
                    wordBreak: "break-word",
                  }}
                  variant="h3">
                  {shortenAnswer(rows.row.answer, 110) + " ..."}
                  <Link
                    style={{
                      cursor: 'pointer'
                    }}
                    onClick={() => openDetailDialog(
                              rows.row.question.value,
                              rows.row.answer
                            )}
                  >
                    more
                  </Link>
                </Typography>
            )
          }
        }
        else if (
            rows.row.type === "text" ||
            rows.row.type === "drop_down" ||
            rows.row.type === "drop_down_state" ||
            rows.row.type === "drop_down_country" ||
            rows.row.type === "checkbox_single") {
          return <Typography variant="h3">{rows.row.answer}</Typography>;
        } else if (rows.row.type === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer !== "Not provided"
                    ?
                    rows.row.answer.map((item, i) => (
                      <FormControlLabel
                        value={item}
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "default" }}
                        control={
                          <Radio
                            disableRipple
                            onClick={(e) => e.preventDefault()}
                            style={{ cursor: "default" }}
                            checked={true}
                            tabIndex={"-1"}
                          />
                        }
                        label={
                          <Typography variant="h3" style={{ color: "#1d1f21" }}>
                            {item}
                          </Typography>
                        }
                      />
                    ))
                    :
                    <Typography variant="h3">{rows.row.answer}</Typography>
                  }
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type === "checkbox_multiple") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer !== "Not provided"
                ?
                rows.row.answer.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={true}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                      <Typography variant="h3">{item}</Typography>
                    </Box>
                  </Box>
                ))
                :
                <Typography variant="h3">{rows.row.answer}</Typography>
              }
              </Grid>
            </Grid>
          );
        }
      },
    },
  ];

  if (loadContent && detailRows.length)
    return (
      <div className={classes.root}>
        {termInfo && (
          <Header
            breadcrumbs={[
              { label: "Applications List", link: `${project_url}/applicant/applications` },
              { label: "Application in " + `${termInfo.name}`, link: null }
            ]}
          />
        )}
        <div className={classes.container}>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Applicant Name:
            </Typography>
            {applicantName && (
            <Typography variant="h3">
              {applicantName}
            </Typography>)}
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Applicant Status:
            </Typography>
            {applicantInfo && (
            <Typography variant="h3">
              {applicantInfo.applicantStatus}
            </Typography>)}
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Date Application Submitted:
            </Typography>
            {applicantInfo && (
            <Typography variant="h3">
              {dayFormat(applicantInfo.createDate.substring(0, 10), "monthDDYYYY")}
            </Typography>)}
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Term Name:
            </Typography>
            {termInfo && termInfo.name && (
            <Typography variant="h3">
              {termInfo.name}
            </Typography>)}
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Term Period:
            </Typography>
            {termInfo && (
            <Typography variant="h3">
              {dayFormat(termInfo.startDate.substring(0, 10), "monthDDYYYY")} - {dayFormat(termInfo.endDate.substring(0, 10), "monthDDYYYY")}
            </Typography>)}
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Application Status:
            </Typography>
            {applicantInfo && applicantInfo.applicationStatus ?
              <Typography variant="h3">
                {applicantInfo.applicationStatus}
              </Typography>
              :
              <Typography variant="h3">
                -
              </Typography>
            }
          </Box>
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Form Name:
            </Typography>
            {formInfo && formInfo.name && (
            <Typography variant="h3">
              {formInfo.name}
            </Typography>)}
          </Box>
          <Box style={{ marginTop: 20 }}>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={detailRows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              autoHeight={true}
              getRowId={(row) => row.index}
              getRowClassName={(rows) => {
                if (rows.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              getRowHeight={() => "auto"}
              hideFooterSelectedRowCount
            />
          </Box>
          <Box
            mt={5}
            ml={2}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.doneButtonStyle}
              onClick={() =>
                navigate(`${project_url}/applicant/applications`)
              }
            >
              Done
            </Button>
          </Box>
        </div>

        {detailAlertMsg.msg && (
          <AlertDialog
            title={detailAlertMsg.title}
            type={detailAlertMsg.type}
            contentMsg={detailAlertMsg.msg}
            headerMsg={detailAlertMsg.headerMsg}
            closeDialog={() => setDetailAlertMsg([])}
          />
        )}
      </div>
    );
  else return;
}

export default ApplicationView;
